import * as React from 'react';

import GenericIconProps from './_icon.type';

function ArrowDownGlyph({ className = 'fill-gray-300' }: GenericIconProps) {
  return (
    <svg
      className={className || ''}
      width="8"
      height="6"
      viewBox="0 0 8 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 6L0.535898 -1.75695e-07L7.4641 4.29987e-07L4 6Z" />
    </svg>
  );
}

export default ArrowDownGlyph;
